module.exports = __webpack_public_path__ + "img/index03.6bf3e0ff.jpg";